<template>

  <el-dialog title="라이센스 수정" 
    :visible.sync="value" 
    :close-on-click-modal="false" 
    :close-on-press-escape="false" 
    :show-close="false"
    @open="dialogOpen">
    <el-form :model="form" ref="form" :label-width="'120px'">

      <el-form-item label="시작일">
        <el-date-picker
          v-model="form.start_date"
          type="date"
          placeholder="시작일">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="종료일">
        <el-date-picker
          v-model="form.expire_date"
          type="date"
          placeholder="종료일">
        </el-date-picker>
      </el-form-item>

      <el-form-item 
        label="디바이스 수" 
        prop="device_vol"
        :rules="[
          { required: true, message: '필수 항목 입니다.'},
          { type: 'number', message: '숫자만 입력 가능합니다.'}
        ]">
        <el-input v-model.number="form.device_vol" autocomplete="off" :disabled="disable_device_vol"></el-input>
      </el-form-item>
      
      <el-form-item
          label="하위사용자 수"
          prop="manager_limit"
          :rules="[
          { required: true, message: '필수 항목 입니다.'},
          { type: 'number', message: '숫자만 입력 가능합니다.'}
        ]">
        <el-input v-model.number="form.manager_limit" autocomplete="off" :disabled="disable_device_vol"></el-input>
      </el-form-item>
      
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">취소</el-button>
      <el-button type="primary" @click="submitForm">확인</el-button>
    </span>
  </el-dialog>

</template>

<script>
import moment from 'moment'
export default {
  props: ['value', 'license'],
  methods: {
    async dialogOpen () {
      this.form.pk = this.license.pk
      this.form.company_fk = this.license.company_fk
      this.form.license_ref = this.license.license_ref
      this.form.start_date = this.license.start_date
      this.form.expire_date = this.license.expire_date
      this.form.device_vol = this.license.device_vol
      this.form.manager_limit = this.license.manager_limit
      this.form.type = this.license.type
      this.disable_type = this.license.type === 'Free'
      this.date_range = [this.form.start_date, this.form.expire_date]
    },
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            pk: this.license.pk,
            company_fk: this.license.company_fk
          }

          let start_odate = this.license.start_date.split('T')[0]
          let start_ndate = moment(this.form.start_date).format('YYYY-MM-DD')
          let expire_odate = this.license.expire_date.split('T')[0]
          let expire_ndate = moment(this.form.expire_date).format('YYYY-MM-DD')
          if (start_odate !== start_ndate) {
            params.start_date = this.form.start_date
          }
          if (expire_odate !== expire_ndate) {
            params.expire_date = this.form.expire_date
          }
          if (this.form.device_vol !== this.license.device_vol) params.device_vol = this.form.device_vol
          if (this.license.type !== 'Free' && this.form.type !== this.license.type) params.type = this.form.type
          if (this.form.manager_limit !== this.license.manager_limit) params.manager_limit = this.form.manager_limit

          this.$emit('close', params)
          this.$refs.form.resetFields()
        }
      });
    },
    close () {
      this.$emit('close')
      this.$refs.form.resetFields()
    }
  },
  data () {
    return {
      form: {
        start_date: '',
        expire_date: '',
        type: '',
        device_vol: null,
        company_fk: null,
        license_ref: null,
        manager_limit: 1,
      },
      date_range: [],
      disable_type: false,
      disable_device_vol: false
    }
  }
}
</script>
